// src/components/pages/Login.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import storageService from '../../services/storageService';
import './Login.css';
import logo from "../../Images/Logo_5.png";
const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already logged in
    const currentUser = storageService.getCurrentUser();
    if (currentUser) {
      navigate('/dashboard');
    }
    
    // Initialize dummy data on first load
    storageService.initializeDummyData();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      const users = storageService.getUsers();
      const user = users.find(u => 
        u.username === username && u.password === password
      );

      if (user) {
        storageService.setCurrentUser(user);
        navigate('/dashboard');
      } else {
        setError('Invalid username or password');
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleDemoLogin = (role) => {
    if (role === 'admin') {
      setUsername('admin');
      setPassword('admin123');
    } else {
      setUsername('recruiter');
      setPassword('recruiter123');
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        {/* Left Side - Branding */}
        <div className="login-left">
         <div className="branding">
  <div className="logo">
    <img 
      src={logo} 
      alt="Logo" 
      className="logo-img"
    />
  </div>

  <h1>JSK Placement CRM</h1>
  <p className="tagline">Streamline Your Recruitment Process</p>
</div>

          
          <div className="features">
            <div className="feature">
              <div className="feature-icon">🏢</div>
              <div className="feature-content">
                <h3>Company Management</h3>
                <p>Manage client companies and their requirements</p>
              </div>
            </div>
            <div className="feature">
              <div className="feature-icon">👤</div>
              <div className="feature-content">
                <h3>Candidate Tracking</h3>
                <p>Track candidates through the entire recruitment cycle</p>
              </div>
            </div>
            <div className="feature">
              <div className="feature-icon">📊</div>
              <div className="feature-content">
                <h3>Analytics & Reports</h3>
                <p>Get insights into your placement performance</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Login Form */}
        <div className="login-right">
          <div className="login-form-container">
            <div className="form-header">
              <h2>Welcome Back</h2>
              <p>Please sign in to your account</p>
            </div>

            {error && (
              <div className="error-message">
                <span className="error-icon">⚠️</span>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <label htmlFor="username">Username</label>
                <input
                  type="text"
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Enter your username"
                  required
                  disabled={loading}
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  required
                  disabled={loading}
                  className="form-input"
                />
              </div>

              <div className="form-options">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                    disabled={loading}
                  />
                  <span>Remember me</span>
                </label>
                <Link to="/forgot-password" className="forgot-password">
                  Forgot password?
                </Link>
              </div>

              <button 
                type="submit" 
                className="login-btn"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-small"></span>
                    Signing in...
                  </>
                ) : 'Sign In'}
              </button>

              <div className="demo-login">
                <p className="demo-label">Quick Demo Login:</p>
                <div className="demo-buttons">
                  {/* <button 
                    type="button"
                    onClick={() => handleDemoLogin('admin')}
                    className="demo-btn admin"
                    disabled={loading}
                  >
                    Admin Login
                  </button> */}
                  {/* <button 
                    type="button"
                    onClick={() => handleDemoLogin('recruiter')}
                    className="demo-btn recruiter"
                    disabled={loading}
                  >
                    Recruiter Login
                  </button> */}
                </div>
              </div>

              <div className="form-footer">
                <p>
                  Don't have an account?{' '}
                  <Link to="/register" className="register-link">
                    Contact administrator
                  </Link>
                </p>
              </div>
            </form>

            <div className="login-info">
              <div className="info-item">
                <span className="info-icon">🔐</span>
                <span>Secure login with encryption</span>
              </div>
              <div className="info-item">
                <span className="info-icon">📱</span>
                <span>Responsive design for all devices</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;